import * as React from "react";
import {inject, observer} from "mobx-react";
import {TableView} from "../../../abstract/TableView";
import {XyiconFeature} from "../../../../../generated/api/base";
import type {User} from "../../../../../data/models/User";
import type {App} from "../../../../../App";
import {CreateUserPanel} from "./CreateUserPanel";
import {UserDetailsContent} from "./UserDetailsContent";

interface IUsersProps {
	readonly app?: App;
}

@inject("app")
@observer
export class UsersView extends React.Component<IUsersProps> {
	private get _headers() {
		const headers = [
			{
				id: "fullName",
				title: "Name",
			},
			{
				id: "email",
				title: "Email",
			},
			{
				id: "status",
				title: "Status",
			},
		];

		if (this.props.app.transport.appState.organization.isSSOEnabledForOrganization) {
			headers.push({
				id: "isSSOEnabledForUser",
				title: "SSO",
			});
		}

		headers.push({
			id: "lastModifiedAt",
			title: "Last Updated",
		});

		return headers;
	}

	private readonly _tableView = React.createRef<TableView<User>>();

	public override componentDidMount() {
		this.props.app.moduleViews[XyiconFeature.User] = this._tableView.current;
	}

	public override render() {
		return (
			<TableView
				ref={this._tableView}
				feature={XyiconFeature.User}
				defaultSort="fullName"
				headers={this._headers}
				create={(onCreated, onCancel, creating) => (
					<CreateUserPanel
						onCancel={onCancel}
						onCreated={onCreated}
						creating={creating}
					/>
				)}
				details={(selected: User[]) => <UserDetailsContent users={selected} />}
			/>
		);
	}
}
